export class CAStatus {
  statusCd: string;
  statusId: number;
  statusDesc: string;
}
